import React, { useState } from 'react'
import { CardContent, makeStyles, IconButton, Typography, Collapse, Grid } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import PropTypes from 'prop-types'
import formatCurrency from 'utils/formatCurrency'
import clsx from 'clsx'
import useEntity from 'hooks/useEntity'
import useCurrentUserProp from 'hooks/useCurrentUserProp'

const useStyles = makeStyles((theme) => ({
  expand: {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  summaryContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  }
}))

export default function Content({ id }) {
  const userContributionsTotal = useCurrentUserProp('donationSumsByJar')[id] || '0'
  const { description, totalDonationsSum, currentSupporterCount } = useEntity('campaigns', id)

  const [showDetails, setShowDetails] = useState(false)
  const classes = useStyles()

  function toggleShowDetails() {
    setShowDetails(!showDetails)
  }

  return (
    <React.Fragment>
      <CardContent className={classes.summaryContent}>
        <Grid container justifyContent='space-between'>
          <Grid item>
            <Typography variant='h6'>
              {formatCurrency(totalDonationsSum)} given
            </Typography>
            <Typography variant='subtitle1'>
              {currentSupporterCount} current supporters
            </Typography>
          </Grid>
          <Grid item>
            <IconButton className={clsx(classes.expand, { [classes.expandOpen]: showDetails })} onClick={toggleShowDetails}>
              <ExpandMore />
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
      <Collapse in={showDetails} unmountOnExit>
        <CardContent>
          <Typography gutterBottom variant='body1'>
            My contribution: {formatCurrency(userContributionsTotal)}
          </Typography>
          <Typography variant='body2'>
            {description}
          </Typography>
        </CardContent>
      </Collapse>
    </React.Fragment>
  )
}

Content.propTypes = {
  id: PropTypes.string.isRequired
}

